module.exports = __webpack_public_path__ + "static/media/260.ad353fa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/260.jpg
// module id = 968
// module chunks = 0